import { combineReducers } from 'redux'
import addOrEditContact from './addOrEditContact'
import auth from './auth'
import contacts from './contacts'
import view from './view'
import email from './email'
import sms from './sms'
import tasks from './tasks'
import loadStatus from './loadStatus'
import luis from './luis'
import AccountSettings from './AccountSettings'
import signupForm from './signupForm'
import onboarding from './onboarding'
import predictions from './predictions'
import data from './data'
import schemas from './schemas'
import campaign from './campaign'
import phonenumbers from './phonenumbers'
import s3Manager from './s3Manager'
import paymentsManager from './paymentsManager'
import deleteReducer from './delete'
import inbox from './inbox'
import sort from './sort'
import search from './search'
import editor from './editor'
import acknowledgement from './acknowledgement'
import voice from './voice'
import snackbar from './snackbar'
import error from './error'
import phone from './phone'
import users from './users'
import customForm from './customForm'
import roundRobin from './roundRobin'
import logoManagementAndBranding from './logoManagementAndBranding'
import cursor from './cursor'
import VastGPT from 'components/VastGPT/redux'
import sortKeys from './sortKeys'
import a2p10dlc from 'components/A2P10DLC/redux'
import userpins from './userpins'
import InboxAI from './InboxAI'

export default combineReducers({
  a2p10dlc,
  AccountSettings,
  addOrEditContact,
  auth,
  contacts,
  campaign,
  data,
  email,
  loadStatus,
  luis,
  signupForm,
  sms,
  tasks,
  view,
  onboarding,
  predictions,
  schemas,
  phonenumbers,
  s3Manager,
  paymentsManager,
  delete: deleteReducer,
  error,
  inbox,
  sort,
  search,
  editor,
  acknowledgement,
  voice,
  snackbar,
  phone,
  users,
  customForm,
  roundRobin,
  logoManagementAndBranding,
  cursor,
  VastGPT,
  sortKeys,
  userpins,
  InboxAI,
})
